import { PerformanceResultType, TemplateKey } from '@/gql/enums';
import type { ResultsProgramItemDataFragment } from '@/gql/graphql';

export interface PerformanceFilterState {
    traineeName: string | null;
    assessmentRunId: string | null;
    groupId: string | null;
    subGroupId: string | null;
    programId: string | null;
    filterAssessmentRunIds: string[];
}

export interface PerformanceTabRef {
    refetch: () => void;
}

export interface AssessmentRunOption {
    value: string;
    label: string;
    groupId: string | null;
    subGroups?: { id: string; name: string }[];
}

export const buildAssessmentRunOptions = (
    programs: ResultsProgramItemDataFragment[],
    filters?: { groupId?: string | null; subGroupId?: string | null }
): AssessmentRunOption[] => {
    const runs: AssessmentRunOption[] = [];

    programs.forEach(program => {
        program.assessmentRuns?.forEach(run => {
            const groupId = run.group?.id ?? null;
            const subGroups = run.subGroups ?? [];

            if (filters?.groupId && groupId !== filters.groupId) {
                return;
            }

            if (filters?.subGroupId && !subGroups.some(sg => sg.id === filters.subGroupId)) {
                return;
            }

            runs.push({
                value: run.id,
                label: run.name,
                groupId,
                subGroups,
            });
        });
    });

    return runs;
};

export const getTemplateKeyByResultType = (resultType: PerformanceResultType): TemplateKey => {
    switch (resultType) {
        case PerformanceResultType.Ippt:
            return TemplateKey.IpptImport;
        case PerformanceResultType.Soc:
            return TemplateKey.SocImport;
        case PerformanceResultType.March20km:
            return TemplateKey.March20kmImport;
        case PerformanceResultType.Weight:
            return TemplateKey.WeightImport;
        case PerformanceResultType.FinSwim:
            return TemplateKey.FinSwimImport;
        case PerformanceResultType.Bmp:
            return TemplateKey.BmpImport;
        default:
            return TemplateKey.IpptImport; // Should not happen
    }
};
